import { message } from "antd";
import React, { useEffect, useState } from "react";

import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Spin } from "antd"

import BusinessService from '../../../../service/business_service'
import TopBarComponent from './../../component/topbar_component'

const BusinessListPage = () => {

    const [businessesList, setBusinessesList] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getMerchants();
        //eslint-disable-next-line
    }, []);



    const getMerchants = async () => {
        try {
            setLoading(true);
            const res = await BusinessService.getMerchants();
            setLoading(false);
            if (res.error) message.error(res.description);
            else {
                setBusinessesList(res.list);
            }
        } catch (error) {
            console.log(error);
        }
    }


    return (
        <div id="main-wrapper" className="admin-dashboard-demos" style={{ background: '#e0e8f3',minHeight: '700px' }} >
            <TopBarComponent />
            <div className="page-content">
                <div className="container">
                    <div className="card content-area">
                        <div className="card-innr">
                            <div className="card-head">
                                <Link to="/business/add" style={{float: 'right'}} className="btn btn-sm btn-outline btn-light"><em className="text-primary ti ti-files" /><span>Add Business</span></Link>
                                <h4 className="card-title">Businesses</h4>
                            </div>
                            <br />
                            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="table-wrap">
                                    <Spin spinning={loading}>
                                        <table className="data-table dt-init user-tnx dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                            <thead>
                                                <tr className="data-item data-head" role="row">
                                                    <th className="data-col dt-tnxno sorting_disabled" rowSpan={1} colSpan={1}>Name</th>
                                                    <th className="data-col dt-token sorting_disabled" rowSpan={1} colSpan={1}>City</th>
                                                    <th className="data-col dt-amount sorting_disabled" rowSpan={1} colSpan={1}>RC Number</th>
                                                    <th className="data-col dt-usd-amount sorting_disabled" rowSpan={1} colSpan={1}>TIN</th>
                                                    <th className="data-col dt-account sorting_disabled" rowSpan={1} colSpan={1}>Type</th>
                                                    <th className="data-col dt-type sorting_disabled" rowSpan={1} colSpan={1}>
                                                        <div className="dt-type-text">View</div>
                                                    </th>
                                                    <th className="data-col sorting_disabled" rowSpan={1} colSpan={1} />
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {/* .data-item */}
                                                {/* .data-item */}
                                                {/* .data-item */}
                                                {/* .data-item */}
                                                {/* .data-item */}
                                                {/* .data-item */}
                                                {/* .data-item */}
                                                {/* .data-item */}


                                                {
                                                    businessesList && businessesList.map((item, i) => {

                                                        return <tr className="data-item odd" role="row" key={i}>
                                                            <td className="data-col dt-tnxno">
                                                                <div className="d-flex align-items-center">
                                                                    <div className="data-state data-state-pending"><span className="d-none">Pending</span></div>
                                                                    <div className="fake-class"><span className="lead tnx-id">{item.businessName}</span><span className="sub sub-date">{item.createdAt}</span></div>
                                                                </div>
                                                            </td>
                                                            <td className="data-col dt-token"><span className="lead token-amount">{item.city}</span><span className="sub sub-symbol">{item.address}</span></td>
                                                            <td className="data-col dt-amount"><span className="lead amount-pay">{item.rcNumber}</span></td>
                                                            <td className="data-col dt-usd-amount"><span className="lead amount-pay">{item.tin}</span></td>
                                                            <td className="data-col dt-account"><span className="lead user-info">{item.businessType}</span><span className="sub sub-date">{item.createdAt}</span></td>
                                                            <td className="data-col dt-type"><span className="dt-type-md badge badge-outline badge-success badge-md">Purchase</span><span className="dt-type-sm badge badge-sq badge-outline badge-success badge-md">P</span></td>
                                                            <td className="data-col text-right">
                                                                
                                                                <ul className="data-action-list d-none d-md-inline-flex">
                                                                    <li><Link to="/business/detail" className="btn btn-light-alt btn-xs btn-icon"><em className="ti ti-eye" /></Link></li>
                                                                </ul>
                                                            </td>
                                                        </tr>

                                                    })
                                                }
                                                
                                            </tbody>
                                        </table>
                                    </Spin>
                                </div>
                                <div className="row align-items-center">
                                    <div className="col-md-9">
                                        <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate">
                                            <ul className="pagination">
                                                <li className="paginate_button page-item previous disabled" id="DataTables_Table_0_previous"><a href="#" aria-controls="DataTables_Table_0" data-dt-idx={0} tabIndex={0} className="page-link">Prev</a></li>
                                                <li className="paginate_button page-item active"><a href="#" aria-controls="DataTables_Table_0" data-dt-idx={1} tabIndex={0} className="page-link">1</a></li>
                                                <li className="paginate_button page-item "><a href="#" aria-controls="DataTables_Table_0" data-dt-idx={2} tabIndex={0} className="page-link">2</a></li>
                                                <li className="paginate_button page-item next" id="DataTables_Table_0_next"><a href="#" aria-controls="DataTables_Table_0" data-dt-idx={3} tabIndex={0} className="page-link">Next</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-md-3 text-left text-md-right">
                                        <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">1 -5 of 8</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* .card-innr */}
                    </div>
                    {/* .card */}
                </div>
                {/* .container */}
            </div>
        </div>
    );

}

export default withRouter(BusinessListPage);
